module.exports = __webpack_public_path__ + "media/images/pic/saska/team/teachers/aleksandra-maslankiewicz-9cc46dd0eafebe5365b094f0b12a6f8e.webp";